export default class RoomBooking {
  constructor() {
    this.id = null;
    this.idRoom = "";
    this.type = "";
    this.name = "";
    this.nameEn = "";
    this.nameTh = "";
    this.areaId = "";
    this.areaNameTh = "";
    this.areaNameEn = "";
    this.capacity = 0;
    this.advanceBooking = 0;
    this.minPeriod = 0;
    this.maxPeriod = 0;
    this.openTime = "";
    this.closeTime = "";
    this.createDate = "";
    this.condition = "";
    this.conditionEn = "";
    this.imageBase64 = "";
  }
}